import React from 'react';
import '../styles/PlatformInfo.css';

function PlatformInfo({ platformStats }) {
  if (!platformStats || !platformStats.feesEnabled) {
    return null;
  }

  return (
    <div className="platform-info">
      <div className="info-grid">
        <div className="info-card">
          <label>Platform Fee</label>
          <strong>{(Number(platformStats.feePercentageBP) / 100).toFixed(2)}%</strong>
        </div>
        <div className="info-card">
          <label>Locks Created</label>
          <strong>{platformStats.totalLocksCreated}</strong>
        </div>
        <div className="info-card highlight">
          <label>Custody</label>
          <strong>Non-Custodial</strong>
        </div>
      </div>
    </div>
  );
}

export default PlatformInfo;
